import { Component, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ORGANISATION_ROLES } from '@careapp-group/core';
import { ConstantSelector } from '../constant-selector.component';

@Component({
  selector: 'ca-role-select',
  templateUrl: './role-select.component.html',
  styleUrls: ['./role-select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RoleSelectComponent), multi: true },
  ],
  standalone: false,
})
export class RoleSelectComponent extends ConstantSelector {
  formControl: UntypedFormControl = new UntypedFormControl('', [Validators.required]);
  protected _defaultOptions = ORGANISATION_ROLES;

  @Input() placeholder;
  @Input() options: string[] = this._defaultOptions;
  @Input() mode: 'dropdown' | 'radio' = 'radio';

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }
}
